<main role="main not-home-page" >
    <div class="container">
        <div class="row">
          <div class="col-md-12 index-up">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a
                          href="javascript:void(0)"
                          [routerLink]="['/']"
                          routerLinkActive="router-link-active"
                          >{{ "Accueil" | translate }}</a
                        >
                      </li>
                      <li class="breadcrumb-item">
                        <a
                          href="javascript:void(0)"
                          [routerLink]="['/publications/actualites']"
                          routerLinkActive="router-link-active"
                          >{{ "Publications" | translate }}</a
                        >
                      </li>
                    <li class="breadcrumb-item active">{{ "general.Archive" | translate }}</li>
                  </ol>
                </nav>
            <h2>{{ "general.Archive" | translate }}</h2>
            <p class="font-weight-semibold text-uppercase">{{"archive.CherchezArchives" | translate}}</p>
            <form class="form-ap" action="" method="get">
              <div class="form-row">
                <div class="col-md-4">
                  <label for="tag">{{"archive.Motscles" | translate}}</label>
                  <input class="form-control" id="tag" type="text" [(ngModel)]="search"  name="search" placeholder="Saisissez un mot clé" (input)= "filterData()">
                </div>
                <div class="col-md-4" *ngIf="arrayDatePub.length > 0">
                  <label for="date-publication">{{"archive.DatePublication" | translate}}</label>
                  <select class="form-control"  (change)="filterData()" [(ngModel)]="selectedDate" name="selectedDate" id="date-publication">
                    <option value=''>{{"archive.ChoisirDate" | translate}}</option>
                    <option *ngFor="let item of arrayDatePub" [value]="item.date">{{item.date}} ({{item.occurence}})</option>
                   
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="categorie">{{"AppelOffre.categorie" | translate}}</label>
                  <select (change)="filterData()" class="form-control" id="categorie" [(ngModel)]="selectedCategorie" name="categorie">
                    <option value=''> {{"AppelOffre.ChoisissezCatégorie" | translate}}</option>
                    <option [value]="item" *ngFor="let item of categories">{{item}}</option>
                  
                  </select>
                </div>
              </div>
              <button class="btn btn-info pr-5" type="submit">{{"archive.FiltrerRecherche" | translate}}<span class="icon-search"></span></button>
            </form>
          </div>
        </div>
      </div>
      <section class="c-appels-offres">
        <div class="container">
          <div class="row">
            <div class="col d-flex justify-content-between">
              <h2 class="size18 text-uppercase mb-3">{{"archive.ResultatRecherche" | translate}}: </h2>
              <p *ngIf="!filtred" class="size18 text-uppercase text-white mt-4 pt-1 mb-3">{{articles.length}} {{"archive.PublicationTrouve" | translate}}</p>
              <p *ngIf="filtred" class="size18 text-uppercase text-white mt-4 pt-1 mb-3">{{dataFiltred.length}} {{"archive.PublicationTrouve" | translate}}</p>
            </div>
          </div>
          <div class="row" data-aos="fade-up" >
            <div class="col-md-12">
              <div *ngFor="let item of dataShow">
                <a *ngIf="item.Code ==='A' " href="javascript:void(0)" [routerLink]="[item.url]" routerLinkActive="router-link-active" >
                  <div class="block-archive d-flex align-items-start flex-column" >
              
                    <div class="d-flex justify-content-end w-100">
                      <h6> <span class="badge badge-secondary blueBack">{{"general.Actualites" | translate}}</span></h6>&nbsp;<h3 class="titre-appels size18">{{item.TitleShow}}</h3>
                      <div class="date-appels">{{item.dateShow}} </div>
                    </div> 
                    <p style="color: black  !important;">{{item.DescriptionShow}}</p>
                  </div>               
                </a>
                <a *ngIf="item.Code ==='C' " [href]="item.fichierLink" target="_blank"  >
                  <div class="block-archive d-flex align-items-start flex-column" >
              
                  <div class="d-flex justify-content-end w-100">
                    <h6> <span class="badge badge-secondary blueBack">{{"general.communiquespresse" | translate}}</span></h6> &nbsp;<h3 class="titre-appels size18">{{item.TitleShow}}</h3>
                    <div class="date-appels">{{item.dateShow}} </div>
                  </div>
                  <p style="color: black  !important;">{{item.DescriptionShow}}</p>
                </div> 
                </a>
              </div>
            
  
               
            
  
            </div>
          </div>
          <div class="row">   
            <div class="col-md-12 text-right"><a class="btn btn-info pr-5" href="javascript:void(0)" (click)="ChargerPlus()">{{"archive.AfficherPlus" | translate}}</a></div>
          </div>
        </div>
      </section>

    </main>
